import { useTranslation } from "react-i18next";

import type { HaNPeopleFloorGroup } from "@lib/logic";

import { FloorSuggestionTile } from "../../shared/FloorSuggestionTile";
import { HaNResultList } from "../../shared/HaNResultList/HaNResultList";
import { PersonRows } from "./PersonRows";

type PeopleOnOtherFloorsProps = {
  floors: HaNPeopleFloorGroup[];
};

// The other floors with people, each under its floor's tile. They start collapsed, so the floors and their counts fit on screen.
export const PeopleOnOtherFloors = ({ floors }: PeopleOnOtherFloorsProps) => {
  const { t } = useTranslation();

  if (floors.length === 0) return null;

  return (
    <>
      <HaNResultList.Header title={t("hereAndNow:PeopleOnOtherFloors")} />

      <div className="flex flex-col gap-2 px-3 py-2">
        {floors.map(({ floorId, direction, people }) => (
          <FloorSuggestionTile
            key={floorId}
            floorId={floorId}
            direction={direction}
            description={t("hereAndNow:PeopleCount", { count: people.length })}
            initiallyExpanded={false}>
            <PersonRows people={people} />
          </FloorSuggestionTile>
        ))}
      </div>
    </>
  );
};
